import checked from '../../../../images/managers/check.svg';

export const selectorOfRecipientsStyles = {
  control: (provided, state) => ({
    ...provided,
    width: '300px',
    borderColor: '#D8D2FF',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    fontSize: '15px',
    lineHeight: '20px',
    fontWeight: '400',
    color: 'rgba(55, 54, 71, 0.7)',
    borderRadius: 0,
    boxShadow: 'none',
    background: '#F9F9FF',
    '&:hover': {
      borderColor: '#A8C0FFFF',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '15px',
    lineHeight: '20px',
    color: 'rgba(55, 54, 71, 0.7)',
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: 0,
    color: 'black',
    width: '19px',
    height: '19px',
    borderRadius: '10px',
    boxShadow: '1px 1px 10px -2px #2D4C8C',
    backgroundColor: '#E9E9FD',
    '&:hover': {
      color: '#A8C0FFFF',
    },
    '& img': {
      height: '7px',
      margin: 'auto',
      transform: state.selectProps.menuIsOpen ? null : 'rotate(180deg)',
    }
  }),
  menu: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
    border: 'none',
    borderTop: 'none',
    borderRadius: '15px',
    boxShadow: 'none',
    animation: 'fadeIn 0.2s linear',
    zIndex: 9999,
    overflowY: 'hidden',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
    font: 'Arimo', // FIXME: use styles and global css-variables
    fontSize: '14px',
    lineHeight: '22px',
    textAlign: 'end',
    maxHeight: '140px',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    // display: 'none',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: 'none',
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '0 20px',
    margin: 'auto',
    height: '28px',
    display: 'flex',
    gap: '.5em',
    color: 'rgba(55, 54, 71, 0.7)',
    fontWeight: '400',
    background: state.isSelected ? 'linear-gradient(270deg, rgba(139, 117, 245, 0.15) 0%, rgba(196, 196, 196, 0) 169.34%)' : provided.backgroundColor,
    justifyContent: 'space-between',
    alignItems: 'center',
    '.expander': {
      flex: '1 1 1px',
    },
    input: {
      display: state.data.special ? 'none' : null,
      borderRadius: '10px',
      appearance: 'none',
      width: '16px',
      height: '16px',
      border: '1px solid #D8D2FF',
      '&:checked': {
        backgroundColor: '#6F8BFF',
        backgroundImage: `url(${checked})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '9px',
        border: 'none'
      }
    },
  }),
}
